/**
 * Location redux actions
 * @module services/location/redux/actions
 */
import { Map } from 'immutable'

export const SET_LOCATION = 'SET_LOCATION'
export const SET_LOCATION_DATA = 'SET_LOCATION_DATA'

/**
 * Create a set location action
 * @param {Object} param0 The parameters
 * @param {Object} param0.location A window location object
 */
export function setLocation ({ location = {} } = {}) {
  return {
    type: SET_LOCATION,
    payload: { location },
  }
}

/**
 * Create a set location data action
 * @param {Object} param0 The parameters
 * @param {Object|Map} param0.data The location data
 */
export function setLocationData ({ data = Map() } = {}) {
  return {
    type: SET_LOCATION_DATA,
    payload: { data },
  }
}
